import { IconInfo } from '@ui/src';
import { HintTypes } from './types';

import cn from './styles.module.css';

const Hint = ({ children }: HintTypes): React.JSX.Element => (
  <div className={cn.hintWrapper}>
    <IconInfo />
    {children && <div className={cn.hintContent}>{children}</div>}
  </div>
);

export default Hint;
